import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/TileButton/TileButton.tsx
import React, { forwardRef, useMemo } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "button";
var TILE_BUTTON_CLASSNAME_MAP = {
  size: {
    "2xs": "pd-size-14",
    xs: "pd-size-20",
    sm: "pd-size-32",
    md: "pd-size-40 pd-p-3",
    lg: "pd-size-48 pd-p-3",
    xl: "pd-size-60 pd-p-6",
    "2xl": "pd-size-72 pd-p-6"
  }
};
var TileButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      size = "md",
      icon = "image",
      isLoading,
      disabled,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "size", "icon", "isLoading", "disabled", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const iconSize = useMemo(() => ["2xs", "xs"].includes(size) ? "lg" : "xl", [size]);
  const showChildren = useMemo(() => ["md", "lg", "xl", "2xl"].includes(size), [size]);
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    disabled,
    className: clsx("pd-tile-button", TILE_BUTTON_CLASSNAME_MAP.size[size], className)
  }, rest), /* @__PURE__ */React.createElement(Icon_default, {
    icon: isLoading ? "spinner" : icon,
    size: iconSize,
    className: clsx(isLoading && "pd-animate-spin")
  }), /* @__PURE__ */React.createElement("div", {
    className: clsx(!showChildren && "pd-sr-only")
  }, children));
});
var StoryTileButton = args => /* @__PURE__ */React.createElement(TileButton, __spreadValues({}, args));
var TileButton_default = TileButton;
export { StoryTileButton, TileButton_default };